import { ThemeProvider } from '@emotion/react'
import { SeamressSnackbarProvider } from './hooks/seamless-snackbar'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import Root from './Root'
import AgoraRTC, {AgoraRTCProvider} from 'agora-rtc-react'
import { theme } from './theme'

const agora_client = AgoraRTC.createClient({ mode: 'rtc', codec: 'av1' })
const qeury_client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const App: React.FC = () => {
  return <>
    <AgoraRTCProvider client={agora_client}>
      <QueryClientProvider client={qeury_client}>
        <ThemeProvider theme={theme}>
          <SeamressSnackbarProvider>
            <Root/>
          </SeamressSnackbarProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </AgoraRTCProvider>
  </>
}

export default App
